import { action, observable, computed } from 'mobx'
import inject from 'helpers/inject'

import StorageService from 'services/storage'
import RouterService from 'services/router'

import authorize from 'tasks/authorize'
import getCurrentUser from 'tasks/getCurrentUser'

import { AuthorizationRoute } from 'routes/config'

export default class AuthService {

  storage = inject(StorageService)
  router = inject(RouterService)

  @observable user

  constructor() {
    if (this.token) this.fetchCurrentUser()
  }

  @computed
  get token() {
    return this.storage.authToken
  }
  set token(value) {
    this.storage.authToken = value
  }

  @computed
  get isAuthorized() {
    return !!this.token
  }

  getIsAuthorized() {
    return this.isAuthorized
  }

  @action.bound
  async authorize(login, password) {
    await authorize.perform(login, password)
    return this.isAuthorized
  }

  @action.bound
  async fetchCurrentUser() {
    this.user = await getCurrentUser.perform()
    return this.user
  }

  @action.bound
  logout() {
    this.token = ''
    this.redirectToAuth()
  }

  @action.bound
  redirectToAuth() {
    this.router.transitionTo(AuthorizationRoute)
  }

}



// WEBPACK FOOTER //
// ./src/services/auth.js